import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllBills = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/bills',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveBill = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/bills',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateBill = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/bills/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteBill = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/bills/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllBills,
  saveBill,
  deleteBill,
  updateBill,
}
